import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import accounting from 'accounting';
import pluralize from 'pluralize';
import { uniq, each, find, cloneDeep, camelCase, lowerCase } from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import { getLoaded, getLoading, getOpportunities } from '../../AnalysisReducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import DropdownRange from '../../../../components/dropdown-range';
import { format as formatMoney } from '../../../../components/money-display';

import Pie from '../graphs/pie';

export function getDefautlIndexFromTotal(total) {
  const lowerIndex = Math.floor((total / 3) - 1);
  const upperIndex = Math.floor((2 * (total / 3)) - 1);
  return [lowerIndex, upperIndex];
}


const REPORT_TYPES = [
  { value: 'AMOUNT', label: 'Amount' },
  { value: 'COUNT', label: 'Count' },
];
const ANNUAL_REVENUE = 'ANNUAL_REVENUE';
const EMPLOYEE_COUNT = 'EMPLOYEE_COUNT';
const SIZE_TYPES = [
  { value: ANNUAL_REVENUE, label: 'Annual Revenue' },
  { value: EMPLOYEE_COUNT, label: 'Employee Count' },
];


export function getBreakDownBuckets(buckets, amountIndex, minIndex, maxIndex, sizeType) {
  const lowerAmount = amountIndex[minIndex];
  const upperAmount = amountIndex[maxIndex];

  const oneStat = {
    total: 0,
    amount: 0,
    min: null,
    max: 0,
    accountIds: [],
    grandTotal: 0,
    stats: {
      won: { total: 0, amount: 0, opportunityIds: [] },
      lost: { total: 0, amount: 0, opportunityIds: [] },
      noDecision: { total: 0, amount: 0, opportunityIds: [] },
    },
  };

  const results = {
    large: cloneDeep(oneStat),
    medium: cloneDeep(oneStat),
    small: cloneDeep(oneStat),
    total: cloneDeep(oneStat),
  };

  each(buckets, (item) => {
    let bucketType = '--';
    const { account } = item;
    if (account) {
      const accountId = account.account_id;
      const value = sizeType === ANNUAL_REVENUE ? account.annual_revenue : account.number_of_employees;
      if (value > lowerAmount && value < upperAmount) {
        bucketType = 'medium';
      } else if (value <= lowerAmount) {
        bucketType = 'small';
      } else if (value >= upperAmount) {
        bucketType = 'large';
      }
      each([bucketType, 'total'], (type) => {
        const bucket = results[type];
        if (bucket) {
          bucket.accountIds.push(accountId);
          const stage = camelCase(item.stage);
          if (bucket.stats[stage]) {
            bucket.amount += item.amount;
            
            bucket.max = Math.max(bucket.max, value);
            if (bucket.min === null) {
              bucket.min = value;
            } else {
              bucket.min = Math.min(bucket.min, value);
            }
  
            bucket.total += 1;
            bucket.stats[stage].total += 1;
            bucket.stats[stage].amount += item.amount || 0;
            bucket.stats[stage].opportunityIds.push(item.opportunity_id);
          }
        } else {
          console.log('');
          console.log('account', account);
          console.log('results', results);
          console.log('type', type);
        }
        
      });
    }
  });
  each(results, (stats) => {
    stats.grandTotal = uniq(stats.accountIds).length;
  });

  return results;
}


const USER_PREFERENCE_REPORT_TYPE = 'outcomes-account-size-report-type';
const USER_PREFERENCE_SIZE_TYPE = 'outcomes-account-size-size-type';

class AccountSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: REPORT_TYPES[0].value,
      sizeType: SIZE_TYPES[0].value,
      annualRevenues: [],
      employeeCounts: [],
      bounds: [],
      buckets: null,
    };

    this.setReportType = this.setReportType.bind(this);
    this.setSizeType = this.setSizeType.bind(this);
    this.onSliderChange = this.onSliderChange.bind(this);
  }

  componentWillMount() {
    const { userPreferences } = this.context;
    const reportType = userPreferences[USER_PREFERENCE_REPORT_TYPE] || REPORT_TYPES[0].value;
    const sizeType = userPreferences[USER_PREFERENCE_SIZE_TYPE] || SIZE_TYPES[0].value;
    this.setState({ reportType, sizeType });
  }

  componentDidMount() {
    if (!this.props.isLoading) {
      this.initData(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isLoading !== nextProps.isLoading && !nextProps.isLoading) {
      this.initData(nextProps);
    }
  }

  onSliderChange(bounds) {
    this.setState({ bounds }, this.gatherData);
  }

  getBucketTitle(title, bucket) {
    const titleSuffix = `ACCOUNT${(bucket.total !== 1 ? 'S' : '')}`;
    return `${title} ${titleSuffix}`;
  }

  getBucketSubTitle(bucket) {
    const { sizeType } = this.state;
    const { organization } = this.props;
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    const min = sizeType === ANNUAL_REVENUE ?
      formatMoney(bucket.min, true, 1, symbol) :
      accounting.formatNumber(bucket.min, 0);
    const max = sizeType === ANNUAL_REVENUE ?
      formatMoney(bucket.max, true, 1, symbol, suffix) :
      `${accounting.formatNumber(bucket.max, 0)} ${pluralize('employee', bucket.max)}`;
    return `${min} - ${max}`;
  }

  setReportType(reportType) {
    this.setState({ reportType });
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, reportType);
  }

  setSizeType(sizeType) {
    const newState = { sizeType };
    if (this.state.sizeType !== sizeType) {
      let { bounds } = this.state;
      if (sizeType === ANNUAL_REVENUE) {
        bounds = getDefautlIndexFromTotal(this.state.annualRevenues.length);
      } else if (sizeType === EMPLOYEE_COUNT) {
        bounds = getDefautlIndexFromTotal(this.state.employeeCounts.length);
      }
      newState.bounds = bounds;
    }
    this.setState(newState, this.gatherData);
    this.context.updateUserPreference(USER_PREFERENCE_SIZE_TYPE, sizeType);
  }

  gatherData() {
    const { opportunities } = this.props;
    const { 
      annualRevenues, employeeCounts, bounds, sizeType,
    } = this.state;
    const buckets = getBreakDownBuckets(opportunities, sizeType === ANNUAL_REVENUE ? annualRevenues : employeeCounts, bounds[0], bounds[1], sizeType);
    this.setState({ buckets });
  }

  initData(props) {
    const { opportunities } = props;
    let annualRevenues = [];
    let employeeCounts = [];

    each(opportunities, (opportunity) => {
      const { account } = opportunity;
      if (account) {
        if (account.annual_revenue >= 0) {
          annualRevenues.push(account.annual_revenue);
        }
        if (account.number_of_employees >= 0) {
          employeeCounts.push(account.number_of_employees);
        }
      }
    });
    annualRevenues = uniq(annualRevenues).sort((a, b) => a - b);
    employeeCounts = uniq(employeeCounts).sort((a, b) => a - b);

    let { bounds } = this.state;
    if (this.state.sizeType === ANNUAL_REVENUE) {
      bounds = getDefautlIndexFromTotal(annualRevenues.length);
    } else if (this.state.sizeType === EMPLOYEE_COUNT) {
      bounds = getDefautlIndexFromTotal(employeeCounts.length);
    }
    this.setState({ bounds, annualRevenues, employeeCounts }, this.gatherData);
  }

  renderGraph() {
    const { buckets, reportType } = this.state;
    const { hasNoDecisionSetup } = this.props;
    if (!buckets) {
      return null;
    }
    const pieReportType = lowerCase(reportType);
    return (
      <div className="row opportunity-graphs">
        <div className="col-sm-4">
          <Pie
            reportType={pieReportType}
            bucket={buckets.small}
            type="small"
            hasNoDecisionSetup={hasNoDecisionSetup}
            subTitle={this.getBucketSubTitle(buckets.small)}
            title={this.getBucketTitle('SMALL', buckets.small)}
            onChartSegmentSelect={this.props.onChartSegmentSelect}
          />
        </div>
        <div className="col-sm-4">
          <Pie
            reportType={pieReportType}
            bucket={buckets.medium}
            type="medium"
            hasNoDecisionSetup={hasNoDecisionSetup}
            subTitle={this.getBucketSubTitle(buckets.medium)}
            title={this.getBucketTitle('MEDIUM', buckets.medium)}
            onChartSegmentSelect={this.props.onChartSegmentSelect}
          />
        </div>
        <div className="col-sm-4">
          <Pie
            reportType={pieReportType}
            bucket={buckets.large}
            type="large"
            hasNoDecisionSetup={hasNoDecisionSetup}
            subTitle={this.getBucketSubTitle(buckets.large)}
            title={this.getBucketTitle('LARGE', buckets.large)}
            onChartSegmentSelect={this.props.onChartSegmentSelect}
          />
        </div>
      </div>
    );
  }

  renderControls() {
    // const { hasNoDecisionSetup } = this.props;
    const { organization } = this.props;
    const { reportType, sizeType, bounds } = this.state;
    const activeReportType = find(REPORT_TYPES, { value: reportType }) || REPORT_TYPES[0];
    const activeSizeType = find(SIZE_TYPES, { value: sizeType }) || SIZE_TYPES[0];

    let fieldSuffix = '';
    let fieldPrefix = '';
    if (organization) {
      fieldSuffix = organization.currency_suffix;
      fieldPrefix = organization.currency_symbol;
    }
    let slideValues = [];
    if (sizeType === ANNUAL_REVENUE) {
      slideValues = this.state.annualRevenues;
    } else if (sizeType === EMPLOYEE_COUNT) {
      slideValues = this.state.employeeCounts;
    }

    return (
      <div className="animated fadeIn" style={{ position: 'relative', zIndex: 10 }}>
        <div>
          <h5 className="sub-header-with-controls">
            View
            {' '}
            <Dropdown
              id="report-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {activeReportType.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {REPORT_TYPES.map(reportItem => (
                  <MenuItem
                    key={reportItem.value}
                    active={reportItem.value === reportType}
                    onSelect={() => { this.setReportType(reportItem.value); }}
                  >
                    {reportItem.label}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            {' '}
            <span>outcome rates in small, medium, and large account with</span>
            {' '}
            <Dropdown
              id="size-type-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {activeSizeType.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {SIZE_TYPES.map(s => (
                  <MenuItem
                    key={s.value}
                    active={s.value === sizeType}
                    onSelect={() => { this.setSizeType(s.value); }}
                  >
                    {s.label}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            {' '}
            <span>boundaries</span>
            {' '}
            <DropdownRange
              values={slideValues}
              bounds={bounds}
              onSliderChange={this.onSliderChange}
              isMoney={sizeType === ANNUAL_REVENUE}
              modalProps={{
                fieldPrefix: sizeType === ANNUAL_REVENUE ? fieldPrefix : '',
                fieldSuffix: sizeType === ANNUAL_REVENUE ? fieldSuffix : '',
                title: `Small, Medium and Large ${sizeType === ANNUAL_REVENUE ? 'Annual Revenue' : 'Employee Count'} Boundaries`,
                lowerLabel: 'Medium Size Start',
                upperLabel: 'Large Size Start',
              }}
            />
          </h5>
        </div>
      </div>
    );
  }

  render() {
    const { isLoading } = this.props;
    return (
      <div>
        {isLoading && <div><ProgressBar /></div>}
        {!isLoading && this.renderControls()}
        {!isLoading && this.renderGraph()}
      </div>
    );
  }
}
AccountSize.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    organization_id: PropTypes.string.isRequired,
  }).isRequired,
  
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onChartSegmentSelect: PropTypes.func,
  opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
AccountSize.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
  onChartSegmentSelect: () => {},
};

// Retrieve data from store as props
function mapStateToProps(state) {
  const loaded = getLoaded(state);
  const loading = getLoading(state);
  return {
    isLoading: !loaded || loading,
    hasNoDecisionSetup: getHasNoDecisionSetup(state),
    organization: getUserCurrentOrganization(state),
    opportunities: getOpportunities(state),
  };
}
export default connect(mapStateToProps)(AccountSize);
